export default [
    {
        id: 0,
        type: 'Administrator'
    },
    {
        id: 1,
        type: 'User'
    },
]